import styled from "styled-components";

export const SLoading = styled.div`
  position: absolute;
  height: 100vh;
  width: 100vw;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  background: var(--primary-light);

  .signal {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100%;
  }

  .signal .text {
    position: absolute;
    font-weight: 700;
    font-size: 1.5em;
    user-select: none;
    pointer-events: none;
  }

  .signal .points {
    position: absolute;
    font-weight: 700;
    font-size: 2rem;
    user-select: none;
    pointer-events: none;
  }

  .signal .text-blue {
    color: var(--primary-dark);
    animation: rotation 7.5s linear infinite;
  }

  .signal .text-point {
    color: var(--primary-dark);
    animation: rotation 7.5s linear infinite;
  }

  .signal .text span {
    position: absolute;
    top: -100px;
    text-transform: uppercase;
    display: inline-block;
    transform-origin: 0 100px;
  }

  .signal .points span {
    position: absolute;
    top: -90px;
    text-transform: uppercase;
    display: inline-block;
    transform-origin: 0 90px;
  }

  .signal .spinner {
    position: absolute;
  }

  .signal i {
    color: var(--primary-dark);
    font-size: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    animation: rotation 2s linear infinite;
  }

  .signal img {
    color: var(--primary-dark);
    height: 4rem;
    display: flex;
    margin-bottom: 0.5rem;
    margin-right: 0.4rem;
    justify-content: center;
    align-items: center;
    animation: scaling 2s linear infinite;
  }

  @keyframes rotation {
    0% {
      transform: rotate(360deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }

  @keyframe scaling {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }
`;
